<template>
  <span :class="`cz-iconfont ${type}`" v-bind="$attrs" />
</template>

<script setup lang="ts" name="BaseIconFont">
  import { toRefs } from 'vue';
  type TProps = {
    // 图标类型
    type: string;
  };

  const props = defineProps<TProps>();
  const { type } = toRefs(props);

  // 用法示例：在线查看 需要用到的图标类型样式名
  // https://www.iconfont.cn/manage/index?manage_type=myprojects&projectId=1343302
  // <BaseIconFont type="czarrow_right" class="xxx" />
</script>
<style>
  .cz-iconfont {
    font-family: cz-iconfont !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>
